import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Dialog,
  TextField,
  DialogContent,
  Divider,
  DialogActions,
  Button,
} from "@material-ui/core";
import * as React from "react";
import { blue } from "@material-ui/core/colors";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { EmployeeModel } from "../model/EmployeeModel";
import EditableTableComponent from "../components/EditableTableComponent";
import { getMomentDate } from "../constants/constants";
const drawerWidth = 340;
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    button: {
      margin: theme.spacing(1),
      width: "30%",
      height: 48,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
    appBar: {
      [theme.breakpoints.up("sm")]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
    },
    menuHideButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    menuShowButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "visible",
      },
      color: "black",
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    avatar: {
      backgroundColor: blue[100],
      color: blue[600],
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
  });
function editComponent(props: any) {
  return (
    <TextField
      value={props.value}
      type="number"
      label={props.columnDef.title}
      InputLabelProps={{
        shrink: true,
      }}
      onChange={(e) => {
        props.onChange(e.target.value);
      }}
    ></TextField>
  );
}
const ADD_DATA_REPORTING_COLUMNS_1 = [
  {
    title: "Date",
    field: "date",
    render: (props: any) => {
      return `${getMomentDate(props.date)}`;
    },
    editComponent: (props: any) => (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          variant="inline"
          format="dd/MM/yyyy"
          id="date-picker-inline"
          // disabled={true}
          label="Date"
          autoOk
          value={props.value}
          onChange={(e) => {
            props.onChange(e);
          }}
          KeyboardButtonProps={{
            "aria-label": "change date",
          }}
        />
      </MuiPickersUtilsProvider>
    ),
  },
  {
    title: "Total Positive cases",
    field: "totalPositiveCases",
    editComponent: (props: any) => {
      return editComponent(props);
    },
  },
  {
    title: "Active cases",
    field: "activeCases",
    editComponent: (props: any) => {
      return editComponent(props);
    },
  },
  {
    title: "Tested",
    field: "tested",
    editComponent: (props: any) => {
      return editComponent(props);
    },
  },

  {
    title: "Positive cases",
    field: "positiveCases",
    editComponent: (props: any) => {
      return editComponent(props);
    },
  },
  {
    title: "Recovered",
    field: "recovered",
    editComponent: (props: any) => {
      return editComponent(props);
    },
  },
  {
    title: "Deaths",
    field: "death",
    editComponent: (props: any) => {
      return editComponent(props);
    },
  },
];
interface Props extends WithStyles<typeof styles> {
  open: any;
  onSaveData: any;
  dialogTitle: any;
  handleClose: any;
  data: any;
}
class AddDataReporting extends React.Component<Props> {
  state = {
    selectedDate: new Date(),
    selectedTime: new Date(),
    selectedPerson: new EmployeeModel(),
    additionalData: new Array<any>(),
  };

  componentDidMount = () => {
    this.setState({
      additionalData: this.props.data ? this.props.data : new Array<any>(),
    });
  };

  componentDidUpdate = (prevProps: any, prevState: any) => {
    if (this.props.data !== prevProps.data) {
      this.setState({
        additionalData: this.props.data ? this.props.data : new Array<any>(),
      });
    }
  };

  onAddDataChanged = (newData: any) => {
    if (!newData.date) {
      newData.date = new Date();
    }
    this.setState((prevState: any) => {
      const additionalData = [...prevState.additionalData];
      additionalData.push(newData);
      return { ...prevState, additionalData };
    });
  };
  onEditDataChanged = (newData: any, oldData: any) => {
    this.setState((prevState: any) => {
      const additionalData = [...prevState.additionalData];
      additionalData[additionalData.indexOf(oldData)] = newData;
      return { ...prevState, additionalData };
    });
  };
  onDeleteataChanged = (oldData: any) => {
    this.setState((prevState: any) => {
      const additionalData = [...prevState.additionalData];
      additionalData.splice(additionalData.indexOf(oldData), 1);
      return { ...prevState, additionalData };
    });
  };

  render() {
    const { open, handleClose, onSaveData } = this.props;

    return (
      <Dialog
        open={open}
        keepMounted={true}
        onClose={() => handleClose()}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        maxWidth={"lg"}
        fullWidth={true}
      >
        <Divider />
        <DialogContent>
          <EditableTableComponent
            title={"Add additional data"}
            columns={ADD_DATA_REPORTING_COLUMNS_1}
            data={this.state.additionalData}
            onAddDataChanged={this.onAddDataChanged}
            onEditDataChanged={this.onEditDataChanged}
            onDeleteataChanged={this.onDeleteataChanged}
          />
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button onClick={() => handleClose()}>{"CANCEL"}</Button>
          <Button onClick={() => onSaveData(this.state.additionalData)}>
            {"SAVE"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default withStyles(styles)(AddDataReporting);
